export const isCartOrder = (order, userCartId) =>
  Boolean(order?.code && userCartId && String(order.code) === String(userCartId));
